// A single scheme allowlist for any user-supplied URL rendered into an <a href>.
// Stored `source_url`s can come from write paths that don't normalize (the
// browser extension, REST/MCP, iOS), so a hostile `javascript:`/`data:` value
// could otherwise execute on click — especially on public pages that render
// OTHER users' links. Returns a safe href, or undefined to drop the link.
const SAFE_SCHEMES = ["http:", "https:", "mailto:"];

export function safeHref(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;
  // Scheme-relative ("//host") and path-relative URLs are fine — they inherit
  // the page origin and can't carry a javascript: payload.
  if (trimmed.startsWith("//") || trimmed.startsWith("/")) return trimmed;
  try {
    const parsed = new URL(trimmed, window.location.origin);
    return SAFE_SCHEMES.includes(parsed.protocol) ? trimmed : undefined;
  } catch {
    // Not parseable as a URL — treat as unsafe rather than pass it through.
    return undefined;
  }
}
